/** A tracked Foundation interaction, and the vendor events it maps to. */
export type FoundationEvent = {
	linkedInId?: number;
	meta?: { action: "track" | "trackCustom"; event: string };
	plausible: string;
};

/**
 * Every tracked Foundation interaction. The only place a vendor's event ID
 * appears: adding a vendor is a field on {@link FoundationEvent} and a branch in
 * the dispatcher, not an edit to any listener.
 */
export const FOUNDATION_EVENTS = {
	applicationSubmitted: {
		linkedInId: 29504858,
		meta: { action: "track", event: "CompleteRegistration" },
		plausible: "RTF Application Submitted",
	},
	discoverPrizes: {
		linkedInId: 29504842,
		meta: { action: "trackCustom", event: "RTF_DiscoverPrizesClick" },
		plausible: "RTF Prize Click",
	},
	formError: { plausible: "RTF Form Error" },
	formProgress: { plausible: "RTF Form Progress" },
	formStart: { plausible: "RTF Form Start" },
	prizeClick: {
		linkedInId: 29504850,
		meta: { action: "track", event: "SubmitApplication" },
		plausible: "RTF Prize Click",
	},
} as const satisfies Record<string, FoundationEvent>;

/** The name of a tracked interaction. */
export type FoundationEventName = keyof typeof FOUNDATION_EVENTS;
